import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { USERS } from "@/constants/testIds";
import { AssignedTemplateBadge, UserIdentityCell, UserRowActions } from "@/components/users/UserRowParts";

export function UserTable({
  users, loading,
  selectedIds, onToggleSelect, onToggleSelectAll,
  onAssign, onToggleStatus, togglingStatus,
  templateNameOf,
}) {
  const allSelected = users.length > 0 && users.every((u) => selectedIds.has(u.id));

  return (
    <Table data-testid={USERS.table}>
      <TableHeader>
        <TableRow>
          <TableHead className="w-10">
            <Checkbox
              checked={allSelected}
              onCheckedChange={onToggleSelectAll}
              aria-label="Seleccionar todos"
              data-testid="select-all-users"
              className="border-slate-300 data-[state=checked]:bg-orange-600 data-[state=checked]:border-orange-600"
            />
          </TableHead>
          <TableHead className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Usuario</TableHead>
          <TableHead className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Cargo</TableHead>
          <TableHead className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Departamento</TableHead>
          <TableHead className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Firma asignada</TableHead>
          <TableHead className="text-right text-xs uppercase tracking-wider text-slate-500 font-semibold">Acción</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {loading && (
          <TableRow>
            <TableCell colSpan={6} className="text-center py-8 text-slate-400 text-sm">Cargando...</TableCell>
          </TableRow>
        )}
        {!loading && users.length === 0 && (
          <TableRow>
            <TableCell colSpan={6} className="text-center py-8 text-slate-400 text-sm">Sin resultados.</TableCell>
          </TableRow>
        )}
        {users.map((u) => (
          <UserRow
            key={u.id}
            user={u}
            selected={selectedIds.has(u.id)}
            onToggleSelect={() => onToggleSelect(u.id)}
            onAssign={() => onAssign(u)}
            onToggleStatus={() => onToggleStatus(u)}
            toggling={togglingStatus === u.id}
            templateName={templateNameOf(u.assigned_template_id)}
          />
        ))}
      </TableBody>
    </Table>
  );
}

function UserRow({ user, selected, onToggleSelect, onAssign, onToggleStatus, toggling, templateName }) {
  const isDisabled = user.status === "disabled";
  return (
    <TableRow className={`hover:bg-slate-50 transition-colors ${isDisabled ? "opacity-60" : ""} ${selected ? "bg-orange-50/40" : ""}`}>
      <TableCell>
        <Checkbox
          checked={selected}
          onCheckedChange={onToggleSelect}
          aria-label={`Seleccionar ${user.display_name}`}
          data-testid={`select-user-${user.id}`}
          className="border-slate-300 data-[state=checked]:bg-orange-600 data-[state=checked]:border-orange-600"
        />
      </TableCell>
      <TableCell><UserIdentityCell user={user} isDisabled={isDisabled} /></TableCell>
      <TableCell className="text-sm text-slate-700">{user.job_title || "—"}</TableCell>
      <TableCell className="text-sm text-slate-700">{user.department || "—"}</TableCell>
      <TableCell>
        <AssignedTemplateBadge assigned={Boolean(user.assigned_template_id)} templateName={templateName} />
      </TableCell>
      <TableCell className="text-right">
        <UserRowActions user={user} isDisabled={isDisabled} toggling={toggling}
          onAssign={onAssign} onToggleStatus={onToggleStatus} />
      </TableCell>
    </TableRow>
  );
}
